import { type ClassValue, clsx } from "clsx"
import { TrendingDown, TrendingUp } from "lucide-react";
import { twMerge } from "tailwind-merge"
import toast from 'react-hot-toast'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}


export const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
  }).format(amount);
};

export const formatPercentage = (value: number) => {
  return `${value >= 0 ? '+' : ''}${value?.toFixed(1)}%`;
};

export const formatGrowth = (growth: number) => {
  const isPositive = growth >= 0;
  return {
    value: `${isPositive ? '+' : ''}${growth?.toFixed(1)}%`,
    color: isPositive ? 'text-green-600' : 'text-red-600',
    icon: isPositive ? TrendingUp : TrendingDown,
  };
};


export const getGrowthIcon = (growth: number) => {
  if (growth > 0) return '📈';
  if (growth < 0) return '📉';
  return '➖';
};

export const ms = {
  seconds: (n: number) => n * 1000,
  minutes: (n: number) => n * 60 * 1000,
  hours: (n: number) => n * 60 * 60 * 1000,
  days: (n: number) => n * 24 * 60 * 60 * 1000,
};




export const handleAnyError = (error: unknown) => {
  const err = (error as { message: string })?.message
  let errorMessage = (error as { response?: { data?: { message?: string | string[] } } })?.response?.data?.message;
  if (Array.isArray(errorMessage)) errorMessage = errorMessage.join(',');

  toast.error(errorMessage || err || 'An unknown error occurred');
}
